import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';
import clsx from 'clsx';

const useStyles = makeStyles(({ typography }) => {
  const size = typography.pxToRem(12);
  return {
    icon: {
      width: size,
      height: size,
    },
  };
});

const AddRemove = () => {
  const styles = useStyles();

  return (
    <SvgIcon
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      className={clsx(styles.icon)}
    >
      <g clipPath="url(#clip0_21_2429)">
        <path d="M9 3H6.5V5H5.5V3H3V2H5.5V0H6.5V2H9V3Z" fill="white" />
        <mask
          id="mask0_21_2429"
          maskUnits="userSpaceOnUse"
          x="3"
          y="4"
          width="6"
          height="6"
        >
          <rect x="3" y="4" width="6" height="6" fill="#C4C4C4" />
        </mask>
        <g mask="url(#mask0_21_2429)">
          <path d="M3 6.4375H9V7.5625H3V6.4375Z" fill="white" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_21_2429">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default memo(AddRemove);
